import { render, staticRenderFns } from "./JoinHeader.vue?vue&type=template&id=99627940&scoped=true&"
import script from "./JoinHeader.vue?vue&type=script&lang=ts&"
export * from "./JoinHeader.vue?vue&type=script&lang=ts&"
import style0 from "./JoinHeader.vue?vue&type=style&index=0&id=99627940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99627940",
  null
  
)

export default component.exports